var hasOwnProperty = Object.prototype.hasOwnProperty;
export { hasOwnProperty };
export var arrayFromSet = Array.from || function (set) {
  var array = [];
  set.forEach(function (item) {
    return array.push(item);
  });
  return array;
};
export function maybeUnsubscribe(entryOrDep) {
  var unsubscribe = entryOrDep.unsubscribe;
  if (typeof unsubscribe === "function") {
    entryOrDep.unsubscribe = void 0;
    unsubscribe();
  }
}